module.exports = __webpack_public_path__ + "img/turnaround_360_online_550x825.763da252.jpg";